// Fichier généré par scripts/fetch-party-logos.ts.
// Les fichiers restent soumis aux licences et éventuels droits de marque indiqués par Wikimedia Commons.

export interface PartyLogoCredit {
  path: string;
  commonsFile: string;
  sourceUrl: string;
  author: string;
  license: string;
  licenseUrl?: string;
  retrievedAt: string;
}

export const partyLogos: Record<string, PartyLogoCredit> = {
  "party-sfio": {
    "path": "/logos/parties/party-sfio.svg",
    "commonsFile": "SFIO.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:SFIO.svg",
    "author": "Unknown authorUnknown author (original creator), ΛΦΠ (vector & upload)",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-action-francaise": {
    "path": "/logos/parties/party-action-francaise.svg",
    "commonsFile": "Logo RN-CRAF 2019.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_RN-CRAF_2019.svg",
    "author": "Original: Restauration Nationale-Centre Royaliste d'Action Française Vector: Mrmw",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "retrievedAt": "2026-08-25"
  },
  "party-jeunesses-patriotes": {
    "path": "/logos/parties/party-jeunesses-patriotes.svg",
    "commonsFile": "Jeunesses Patriotes.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Jeunesses_Patriotes.svg",
    "author": "Asqueladd",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-pcf": {
    "path": "/logos/parties/party-pcf.svg",
    "commonsFile": "Logo – Parti communiste français (2018).svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_%E2%80%93_Parti_communiste_fran%C3%A7ais_(2018).svg",
    "author": "Parti communiste français",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-mrp": {
    "path": "/logos/parties/party-mrp.jpg",
    "commonsFile": "Mouvement Républicain Populaire logo.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Mouvement_R%C3%A9publicain_Populaire_logo.jpg",
    "author": "Fernán De Soto",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-rpf": {
    "path": "/logos/parties/party-rpf.png",
    "commonsFile": "Rally of the French People logo.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Rally_of_the_French_People_logo.svg",
    "author": "HapHaxion",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-25"
  },
  "party-mdc": {
    "path": "/logos/parties/party-mdc.jpg",
    "commonsFile": "Logo mouvement des citoyens 2024.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_mouvement_des_citoyens_2024.jpg",
    "author": "Rtebte",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-25"
  },
  "party-rpf-1999": {
    "path": "/logos/parties/party-rpf-1999.png",
    "commonsFile": "Logo du Rassemblement pour la France (SVG).svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_du_Rassemblement_pour_la_France_(SVG).svg",
    "author": "Legrandbigre",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-25"
  },
  "party-mnr": {
    "path": "/logos/parties/party-mnr.png",
    "commonsFile": "Mnr logo.png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Mnr_logo.png",
    "author": "Les amis du MNR",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "retrievedAt": "2026-08-25"
  },
  "party-modem": {
    "path": "/logos/parties/party-modem.png",
    "commonsFile": "MoDem logo 2019.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:MoDem_logo_2019.svg",
    "author": "Mouvement Démocrate",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-parti-gauche": {
    "path": "/logos/parties/party-parti-gauche.png",
    "commonsFile": "Nouveau logotype PG.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Nouveau_logotype_PG.svg",
    "author": "Tidiview",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-front-gauche": {
    "path": "/logos/parties/party-front-gauche.png",
    "commonsFile": "Left Front logo.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Left_Front_logo.svg",
    "author": "Unknown authorUnknown author",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "retrievedAt": "2026-08-25"
  },
  "party-npa": {
    "path": "/logos/parties/party-npa.jpg",
    "commonsFile": "Logo du NPA - l'Anticapitaliste.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_du_NPA_-_l%27Anticapitaliste.jpg",
    "author": "Unknown authorUnknown author",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "retrievedAt": "2026-08-25"
  },
  "party-eelv": {
    "path": "/logos/parties/party-eelv.png",
    "commonsFile": "Europe Ecologie-Les Verts Logo.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Europe_Ecologie-Les_Verts_Logo.svg",
    "author": "Unknown authorUnknown author",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-lfi": {
    "path": "/logos/parties/party-lfi.png",
    "commonsFile": "LFI Logo 2024.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:LFI_Logo_2024.svg",
    "author": "GlowstoneUnknown",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-lrem": {
    "path": "/logos/parties/party-lrem.png",
    "commonsFile": "Logo En Marche !.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_En_Marche_!.svg",
    "author": "En Marche !, Vectorization: Tubezlob",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-lr": {
    "path": "/logos/parties/party-lr.png",
    "commonsFile": "Les Républicains - logo (France, 2023).svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Les_R%C3%A9publicains_-_logo_(France,_2023).svg",
    "author": "Les Républicains",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-dlf": {
    "path": "/logos/parties/party-dlf.png",
    "commonsFile": "Debout la France logo (2017).svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Debout_la_France_logo_(2017).svg",
    "author": "Debout la France",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-upr": {
    "path": "/logos/parties/party-upr.png",
    "commonsFile": "Logo Union Populaire Républicaine.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_Union_Populaire_R%C3%A9publicaine.svg",
    "author": "Union populaire républicaine",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-rn": {
    "path": "/logos/parties/party-rn.png",
    "commonsFile": "Logo Rassemblement National.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_Rassemblement_National.svg",
    "author": "Rassemblement national",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-nupes": {
    "path": "/logos/parties/party-nupes.png",
    "commonsFile": "LogoNUPES.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:LogoNUPES.svg",
    "author": "Original: Nouvelle Union Populaire Ecologique et Sociale Vector: Ryse93",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-reconquete": {
    "path": "/logos/parties/party-reconquete.png",
    "commonsFile": "Logo du parti Reconquête.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_du_parti_Reconqu%C3%AAte.svg",
    "author": "Reconquête",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-attac": {
    "path": "/logos/parties/party-attac.gif",
    "commonsFile": "Logo-attac.gif",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo-attac.gif",
    "author": "Attac",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-prl": {
    "path": "/logos/parties/party-prl.png",
    "commonsFile": "Parti Republicain de la Liberte.png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Parti_Republicain_de_la_Liberte.png",
    "author": "Danrolo",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-25"
  },
  "party-psu": {
    "path": "/logos/parties/party-psu.png",
    "commonsFile": "Logo Parti Socialiste Unifié.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_Parti_Socialiste_Unifi%C3%A9.svg",
    "author": "Fauntleroy",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-25"
  },
  "party-oas": {
    "path": "/logos/parties/party-oas.png",
    "commonsFile": "Emblème de l'OAS.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Embl%C3%A8me_de_l%27OAS.svg",
    "author": "Alejandro Basombrio",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-25"
  },
  "party-cir": {
    "path": "/logos/parties/party-cir.png",
    "commonsFile": "LogoCIR.png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:LogoCIR.png",
    "author": "Achille80",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-25"
  },
  "party-fgds": {
    "path": "/logos/parties/party-fgds.png",
    "commonsFile": "LogoFGDS.png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:LogoFGDS.png",
    "author": "Auteur inconnu",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-25"
  },
  "party-centre-democratie-progres": {
    "path": "/logos/parties/party-centre-democratie-progres.png",
    "commonsFile": "Logo of the Democrats and Progressives.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_of_the_Democrats_and_Progressives.svg",
    "author": "Démocrates et Progressistes",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-fnri": {
    "path": "/logos/parties/party-fnri.png",
    "commonsFile": "Independent Republicans France.png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Independent_Republicans_France.png",
    "author": "Sciences Po",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-25"
  },
  "party-udr": {
    "path": "/logos/parties/party-udr.png",
    "commonsFile": "Logo-UDR.png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo-UDR.png",
    "author": "Danrolo",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-25"
  },
  "party-ps-1969": {
    "path": "/logos/parties/party-ps-1969.png",
    "commonsFile": "Le Parti socialiste wordmark.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Le_Parti_socialiste_wordmark.svg",
    "author": "Le Parti socialiste",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-amis-terre": {
    "path": "/logos/parties/party-amis-terre.png",
    "commonsFile": "Friends of the Earth logo.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Friends_of_the_Earth_logo.svg",
    "author": "Friends of the Earth; SVG conversion by WClarke",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-pno": {
    "path": "/logos/parties/party-pno.png",
    "commonsFile": "Partit de la Nacion Occitana.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Partit_de_la_Nacion_Occitana.svg",
    "author": "Xophe84",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-25"
  },
  "party-lcr": {
    "path": "/logos/parties/party-lcr.png",
    "commonsFile": "Logo LCR rouge.png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_LCR_rouge.png",
    "author": "LCR",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-lutte-ouvriere": {
    "path": "/logos/parties/party-lutte-ouvriere.png",
    "commonsFile": "Logo Lutte Ouvrière.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_Lutte_Ouvri%C3%A8re.svg",
    "author": "Probably Édouard Taubé (Mody)",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-prg": {
    "path": "/logos/parties/party-prg.png",
    "commonsFile": "Logo - PRG, le centre gauche.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_-_PRG,_le_centre_gauche.svg",
    "author": "HapHaxion",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "retrievedAt": "2026-08-25"
  },
  "party-cds": {
    "path": "/logos/parties/party-cds.png",
    "commonsFile": "CDS France.png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:CDS_France.png",
    "author": "la Bibliothèque nationale de France",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-25"
  },
  "party-parti-republicain-1977": {
    "path": "/logos/parties/party-parti-republicain-1977.png",
    "commonsFile": "Parti républicain.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Parti_r%C3%A9publicain.svg",
    "author": "幻光尘",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-25"
  },
  "party-udf": {
    "path": "/logos/parties/party-udf.png",
    "commonsFile": "Union pour la Démocratie Drançaise - logo (France, 1978-1991).svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Union_pour_la_D%C3%A9mocratie_Dran%C3%A7aise_-_logo_(France,_1978-1991).svg",
    "author": "UDF",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-fn": {
    "path": "/logos/parties/party-fn.png",
    "commonsFile": "Rassemblement National.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Rassemblement_National.svg",
    "author": "jpfabre",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-pfn": {
    "path": "/logos/parties/party-pfn.png",
    "commonsFile": "Parti des forces nouvelles.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Parti_des_forces_nouvelles.svg",
    "author": "Xophe84",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-parti-travailleurs": {
    "path": "/logos/parties/party-parti-travailleurs.png",
    "commonsFile": "Logo Parti des travailleurs.png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_Parti_des_travailleurs.png",
    "author": "Own work",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-mppt": {
    "path": "/logos/parties/party-mppt.png",
    "commonsFile": "Logo MPPT.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_MPPT.svg",
    "author": "Mouvement pour un parti des travailleurs, vectorized by Kokluts",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-parti-occitan-1987": {
    "path": "/logos/parties/party-parti-occitan-1987.png",
    "commonsFile": "Partit-occitan-2015.png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Partit-occitan-2015.png",
    "author": "Partit Occitan",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-25"
  },
  "party-unr": {
    "path": "/logos/parties/party-unr.png",
    "commonsFile": "Croix de Lorraine.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Croix_de_Lorraine.svg",
    "author": "Cerveaugenie",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-pdp": {
    "path": "/logos/parties/party-pdp.png",
    "commonsFile": "PDP.png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:PDP.png",
    "author": "Fer1997",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-faisceau": {
    "path": "/logos/parties/party-faisceau.jpg",
    "commonsFile": "Le Faisceau Logo.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Le_Faisceau_Logo.jpg",
    "author": "Georges Valois",
    "license": "Public domain",
    "retrievedAt": "2026-08-25"
  },
  "party-croix-de-feu": {
    "path": "/logos/parties/party-croix-de-feu.png",
    "commonsFile": "Croix de Feu.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Croix_de_Feu.svg",
    "author": "Fauntleroy",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-25"
  },
  "party-social-francais": {
    "path": "/logos/parties/party-social-francais.png",
    "commonsFile": "French Social Party emblem.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:French_Social_Party_emblem.svg",
    "author": "Dahn",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-25"
  },
  "party-ppf": {
    "path": "/logos/parties/party-ppf.png",
    "commonsFile": "Logo du Parti populaire francais.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_du_Parti_populaire_francais.svg",
    "author": "R-41",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "retrievedAt": "2026-08-25"
  },
  "party-francisme": {
    "path": "/logos/parties/party-francisme.png",
    "commonsFile": "Logo of Mouvement Franciste.svg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Logo_of_Mouvement_Franciste.svg",
    "author": "Mrmw",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "retrievedAt": "2026-08-25"
  }
};
